var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.819,
    height: 24,
    viewBox: "0 0 21.819 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(0.001 -42.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M138.973,451.273A4.1,4.1,0,0,0,142.981,448h-8.016a4.1,4.1,0,0,0,4.008,3.273Zm0,0",
    transform: "translate(-128.064 -384.605)",
    fill: "#344563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M18.558,53.576h-.013a7.645,7.645,0,0,1-7.636-7.636,7.568,7.568,0,0,1,.73-3.236c-.24-.023-.483-.037-.73-.037A7.636,7.636,0,0,0,3.272,50.3v3.041a7.315,7.315,0,0,1-2.605,5.6,1.909,1.909,0,0,0-.6,1.959,2,2,0,0,0,1.962,1.4H19.783a2,2,0,0,0,1.994-1.513,1.912,1.912,0,0,0-.651-1.868,7.259,7.259,0,0,1-2.568-5.348Zm0,0",
    fill: "#344563"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.dba92bd0f9c5610962e483fa4b9941d3.svg";
export { ForwardRef as ReactComponent };